export default {
    子分类: "子分类",
    商品图号: "商品图号",
    查看详情: "查看详情",
    图号: "图号",
    加入购物车: "加入购物车",
    首页: "首页",
    确认退出吗: "确认退出吗",
    确认: "确认",
    取消: "取消",
    我的订单: "我的订单",
    购物车: "购物车",
    总分类: "总分类",
    更多: "更多",
    默认排序: "默认排序",
    价格排序: "价格排序",
    暂无数据: "暂无数据",
    请输入要查询的单号: "请输入要查询的单号",
    查询: "查询",
    最近一周: "最近一周",
    最近一个月: "最近一个月",
    最近三个月: "最近三个月",
    所有日期: "所有日期",
    至: "至",
    确定删除本条商品吗: "确定删除本条商品吗",
    删除: "删除",
    已选择: "已选择",
    件: "件",
    商品合计: "商品合计",
    下单结算: "下单结算",
    商品信息: "商品信息",
    单价: "单价",
    数量: "数量",
    小计: "小计",
    操作: "操作",
    共: "共",
    件商品: "件商品",
    验证码必须为数字: "验证码必须为数字",
    手机号必须为数字: "手机号必须为数字",
    手机号必须为字母或数字: "手机号必须为字母或数字",
    账号不能为空: "账号不能为空",
    密码不能为空: "密码不能为空",
    请输入密码: "请输入密码",
    请输入手机号: "请输入手机号",
    用户登录: "用户登录",
    退出登录: "退出登录",
    登录中: "登录中",
    获取验证码: "获取验证码",
    手机号不能为空: "手机号不能为空",
    请输入关键字: "请输入关键字",
    请输入内容: "请输入内容",
    订单编号: "订单编号",
    合计: "合计",
    未审核: "未审核",
    下单时间: "下单时间",
    适用车型: "适用车型",
    详情咨询: "详情咨询",
    描述文字: "描述文字",
    商品详情: "商品详情",
    商品名称: "商品名称",
    商品规格: "商品规格",
    外文名称: "外文名称",
    商品尺寸: "商品尺寸",
    商品体积: "商品体积",
    商品重量: "商品重量",
    欢迎来到: "欢迎来到",
    网站: "网站",
    俄文: "俄文",
    英文: "英文",
    中文: "中文",
    商品序号: "Sku",
    俄文名称: "俄文名称",
    英文名称: "英文名称",
    暂无图片: "暂无图片",
    重置: "重置",
    批量删除: "批量删除",
    请输入商品名称: "请输入商品名称",
    今日: "今日",
    昨日: "昨日",
    本周: "本周",
    本年: "本年",
    本月: "本月",
    已审核: "已审核",
    备注: "备注",
    修改: "修改",
    备注信息: "备注信息",
    保存: "保存",
    该单据已审核请联系管理员: "该单据已审核，请联系管理员。",    
    密码登录: "密码登录",
    手机号: "手机号",
    密码: "密码",
    登录账号: "登录账号",
}